import { render, staticRenderFns } from "./inspectInventory.vue?vue&type=template&id=573da5b8&scoped=true"
import script from "./inspectInventory.vue?vue&type=script&lang=ts"
export * from "./inspectInventory.vue?vue&type=script&lang=ts"
import style0 from "./inspectInventory.vue?vue&type=style&index=0&id=573da5b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573da5b8",
  null
  
)

export default component.exports